"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PaginationDefaultProps = exports.Pagination = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icons = require("../../foundation/Icons");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Pagination = function Pagination(props) {
  var className = props.className,
      disabled = props.disabled,
      alwaysShow = props.alwaysShow,
      pageWindow = props.pageWindow,
      currentPage = props.currentPage,
      totalPages = props.totalPages,
      onPageChange = props.onPageChange,
      NewProps = _objectWithoutProperties(props, ["className", "disabled", "alwaysShow", "pageWindow", "currentPage", "totalPages", "onPageChange"]); // Handle incorrect parameters so they make some sense!
  // - currentPage must be between 1 and totalPages
  // - totalPages must be greater or equal to currentPage
  // - pageWindow must be positive


  var myCurrentPage = currentPage >= 1 && currentPage <= totalPages ? currentPage : 1;
  var myTotalPages = totalPages >= myCurrentPage ? totalPages : myCurrentPage;
  var myPageWindow = pageWindow >= 1 ? pageWindow : 5;

  var changeCurrentPage = function changeCurrentPage(changedPageNumber) {
    // Ensure number between minimum 1 and maximum totalPages
    var pageNumber = Math.min(Math.max(1, changedPageNumber), totalPages);
    onPageChange(pageNumber);
  }; // If there is no pagination required then return empty.


  if (!alwaysShow && myTotalPages < 2) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null); // null not compatible with JSX.Element so need to use fragment.
  } // Do we need to add chevrons and carets to the display?


  var addCaret = myTotalPages > myPageWindow;
  var caretLeftDisabled = disabled || myCurrentPage < myPageWindow;
  var caretRightDisabled = disabled || myCurrentPage + myPageWindow > myTotalPages;
  var chevronLeftDisabled = disabled || myCurrentPage <= 1;
  var chevronRightDisabled = disabled || myCurrentPage >= myTotalPages;
  var classNameComponent = (0, _classnames.default)('pagination-component', className, {
    'pagination-component--disabled': disabled
  });
  var classNameCaretLeft = (0, _classnames.default)({
    'pagination-component__caret': true,
    'pagination-component__caret-left': true,
    'pagination-component__caret--disabled': caretLeftDisabled
  });
  var classNameCaretRight = (0, _classnames.default)({
    'pagination-component__caret': true,
    'pagination-component__caret-right': true,
    'pagination-component__caret--disabled': caretRightDisabled
  });
  var classNameChevronLeft = (0, _classnames.default)({
    'pagination-component__chevron': true,
    'pagination-component__chevron-left': true,
    'pagination-component__chevron--disabled': chevronLeftDisabled
  });
  var classNameChevronRight = (0, _classnames.default)({
    'pagination-component__chevron': true,
    'pagination-component__chevron-right': true,
    'pagination-component__chevron--disabled': chevronRightDisabled
  }); // Work out where page numbers that should show in the navigation.

  var pagesEitherSide = Math.ceil(myPageWindow / 2);
  var startPageNumber = myCurrentPage - pagesEitherSide;
  var endPageNumber = myCurrentPage + pagesEitherSide; // Page Window is larger than total pages then show all pages

  if (myTotalPages < myPageWindow) {
    startPageNumber = 1;
    endPageNumber = myTotalPages;
  } else if (myCurrentPage < pagesEitherSide) {
    // if the current page is less than the page count to the left then start from 1.
    startPageNumber = 1;
    endPageNumber = Math.min(myPageWindow, myTotalPages);
  } else if (myCurrentPage > myTotalPages - pagesEitherSide) {
    // if the current page is more than the page count to the right then end at myTotalPages.
    endPageNumber = myTotalPages;
    startPageNumber = Math.max(1, myTotalPages - myPageWindow);
  }

  if (startPageNumber < 1) {
    // Sanity check we haven't gone out of bounds.
    startPageNumber = 1;
    endPageNumber = Math.min(myPageWindow, myTotalPages);
  }

  if (endPageNumber > myTotalPages) {
    endPageNumber = myTotalPages;
    startPageNumber = Math.max(1, endPageNumber - myPageWindow);
  } // ADA compliant - allow an enter key to act like a click.


  var _handleKeyPress = function _handleKeyPress(target) {
    if (target.key === 'Enter') {
      target.currentTarget.click();
    }
  };

  var pageButtons = [];

  var _loop = function _loop(pageButtonPageNumber) {
    var myClassNamePageButton = (0, _classnames.default)({
      'pagination-component__pagebutton': true,
      'pagination-component__pagebutton--disabled': disabled,
      'pagination-component__pagebutton--selected': pageButtonPageNumber === myCurrentPage
    });
    pageButtons.push( /*#__PURE__*/_react.default.createElement("div", {
      key: pageButtonPageNumber,
      onClick: function onClick() {
        if (pageButtonPageNumber !== myCurrentPage && !disabled) {
          changeCurrentPage(pageButtonPageNumber);
        }
      },
      tabIndex: 0,
      role: "button",
      onKeyDown: _handleKeyPress,
      className: myClassNamePageButton
    }, pageButtonPageNumber));
  };

  for (var pageButtonPageNumber = startPageNumber; pageButtonPageNumber <= endPageNumber; pageButtonPageNumber += 1) {
    _loop(pageButtonPageNumber);
  }

  var caretLeftParams = caretLeftDisabled ? {} : {
    onClick: function onClick() {
      changeCurrentPage(myCurrentPage - myPageWindow);
    },
    tabIndex: 0,
    role: 'button',
    onKeyDown: _handleKeyPress
  };
  var chevronLeftParams = chevronLeftDisabled ? {} : {
    onClick: function onClick() {
      changeCurrentPage(myCurrentPage - 1);
    },
    tabIndex: 0,
    role: 'button',
    onKeyDown: _handleKeyPress
  };
  var caretRightParams = caretRightDisabled ? {} : {
    onClick: function onClick() {
      changeCurrentPage(myCurrentPage + myPageWindow);
    },
    tabIndex: 0,
    role: 'button',
    onKeyDown: _handleKeyPress
  };
  var chevronRightParams = chevronRightDisabled ? {} : {
    onClick: function onClick() {
      changeCurrentPage(myCurrentPage + 1);
    },
    tabIndex: 0,
    role: 'button',
    onKeyDown: _handleKeyPress
  };
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: classNameComponent
  }, NewProps), /*#__PURE__*/_react.default.createElement("div", {
    className: 'pagination-component__container'
  }, addCaret && /*#__PURE__*/_react.default.createElement("div", _extends({
    className: classNameCaretLeft,
    "aria-label": "Move back ".concat(myPageWindow, " pages")
  }, caretLeftParams), /*#__PURE__*/_react.default.createElement(_Icons.IcoCaretLeft, {
    fixedWidth: true
  })), /*#__PURE__*/_react.default.createElement("div", _extends({
    className: classNameChevronLeft,
    "aria-label": 'Move back one page'
  }, chevronLeftParams), /*#__PURE__*/_react.default.createElement(_Icons.IcoChevronLeft, {
    fixedWidth: true
  })), pageButtons, /*#__PURE__*/_react.default.createElement("div", _extends({
    className: classNameChevronRight,
    "aria-label": 'Move forward one page'
  }, chevronRightParams), /*#__PURE__*/_react.default.createElement(_Icons.IcoChevronRight, {
    fixedWidth: true
  })), addCaret && /*#__PURE__*/_react.default.createElement("div", _extends({
    className: classNameCaretRight,
    "aria-label": "Move forward ".concat(myPageWindow, " pages")
  }, caretRightParams), /*#__PURE__*/_react.default.createElement(_Icons.IcoCaretRight, {
    fixedWidth: true
  }))));
};

exports.Pagination = Pagination;
Pagination.propTypes = {
  className: _propTypes.default.any.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  pageWindow: _propTypes.default.number.isRequired,
  alwaysShow: _propTypes.default.bool.isRequired,
  onPageChange: _propTypes.default.func.isRequired,
  currentPage: _propTypes.default.number.isRequired,
  totalPages: _propTypes.default.number.isRequired
};
var PaginationDefaultProps = {
  className: '',
  disabled: false,
  pageWindow: 5,
  alwaysShow: false
};
exports.PaginationDefaultProps = PaginationDefaultProps;
Pagination.defaultProps = PaginationDefaultProps;
var _default = Pagination;
exports.default = _default;